app.service('updateServicePrices', function (price, orderConfig) {

	function run(options) {
		var total = orderConfig.getData().servicesItemsWorth;
		options.$inputs.filter(':checked').each(function () {
			//console.log($(this).attr('data-quantity') / 1 , $(this).data('price'))
			total = price.add(total, ($(this).attr('data-quantity') / 1) * ($(this).data('price') / 1));
		});
		options.$box.text(price.format(total));
	}

	return {
		run
	};
});